import * as React from 'react'
import { ReferralsContext } from './context'
import type { ReactElement } from 'react'
import { useData } from './hooks'

type Props = {
  children: ReactElement
}

export function ReferralsContextProvider(props: Props) {
  const { children } = props
  const { value } = useData()

  return (
    <ReferralsContext.Provider value={value}>
      {children}
    </ReferralsContext.Provider>
  )
}
